import Table from '/src/components/table/Table.js';
import { useState , useEffect } from 'react';
import Icons from '/src/features/phone/data/types/Icons';
import './ConversationTableInProgress.css';
import ConversationDetailsModal from '../../ConversationDetailsModal/ConversationDetailsModal';
import NiceModal from '@ebay/nice-modal-react';
import ConversationFilterModal from '../../ConversationFilter/ConversationFilterModal';
import IconButton from '/src/components/UI/Button/IconButton/IconButton';
import ConversationInProgressService from '../../../services/ConversationInProgressService';
import { getStorageParamForCurrentCompany } from '/src/utils/storageParamForCurrentCompany';
import capitalizeFirstLetter from '/src/utils/capitalizeFirstLetter';
import formatPhoneNumber from '/src/utils/formatPhoneNumber';
import ConversationMarker from '../../ConversationMarker/ConversationMarker';
import getCutToken from "/src/utils/getCutToken";
import getDuration from '../../../data/getDuration';
import getNumberOfInteraction from '../../../data/getNumberOfInteraction';
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';
import "../Completed/ConversationTableCompleted.css"

function ConversationTableInProgress({setRefreshList}) {

    const { getConversations } = ConversationInProgressService;
    const [filterValues, setFilterValues] = useState(getStorageParamForCurrentCompany('conversation_filters'));
    const [refreshTable, setRefreshTable] = useState(false)

    const toast = useToastDispatchContext();

    const cells = [
        {
            name: 'channel_type.name',
            column: 'Channel',
            show: (value) => <img width="20px" srcSet={Icons[value]}></img>
        },
        {
            name: 'instance_id',
            column: 'ID',
            show: (value) => <span style={{ color: "var(--main)", cursor: "pointer" }} onClick={(e) => navigator.clipboard.writeText(value).then(_ => { toast.success('Copy token to clipboard', 'You can paste this token where you need !', 5000); })}>  {getCutToken(value)}</span>,
        },
        {
            name: 'bot.name',
            column: 'Bot',
            show: (value) => capitalizeFirstLetter(value),
            sort: true
        },
        
        {
            name: 'messages',
            column: 'Interactions',
            show: (value) => getNumberOfInteraction(value),
        },
        {
            name: 'caller',
            column: 'Caller',
            show: (value) => formatPhoneNumber(value)
        },
        {
            name: 'numbers',
            column: 'Called',
            show: (value) => formatPhoneNumber(value)
        },
        {
            name: 'markers',
            column: 'Markers',
            show: (value) => <div className='list_makers_conversation_table'> {value.map((marker, i) => i < 3 && (<ConversationMarker key={marker.id || i} marker={marker} className={i !== 0 ? "superposition_maker_conversation_circle" : undefined}  style={{ left: "-" + 9 * i + "px", zIndex: i }} />))}</div>

        }
    ];

    const handleTableRefresh = () => {
        setRefreshTable(!refreshTable); // Mettre à jour le tableau
    }

    const handleFilterSubmit = (filters) => {
        setFilterValues(filters);
    };

    const onClickSearch = () => {
        NiceModal.show(ConversationFilterModal, {
            title: 'Search conversation',
            postbackAction: handleFilterSubmit,
            mode: 1

        })
    }

    const onClickView = ({ updateRow, row }) => {
        NiceModal.show(ConversationDetailsModal, {
            data: row,
            title: 'Conversation details',
            state: 2,
            onRefresh: handleTableRefresh
        }).then((conversation) => updateRow(conversation))
    }

    const actions = [
        { className: "fas fa-file-alt action-button profil_action", style: {}, onClick: onClickView, title: "Details" },
        // {className : "fas fa-thumbtack action-button profil_action", style : {}, onClick : onClickView,title: "mark conversation" },
        //{className : "fas fa-trash action-button delete_action", style : {}, onClick : onClickDelete,title: "Delete conversation" },
    ];
    const buttons = [
        { icon:"fas fa-sync" , onClick: handleTableRefresh },
        { className: "main-iconButton profil_action main_add-button" + (!Object.keys(filterValues).length == 0 ? " conversations_active_filter" : ""), icon:"fas fa-filter", onClick:onClickSearch},

    ].filter(button => button);

    useEffect( ()=>{
        setRefreshList();
    },[filterValues])

    return (
        <Table name="conversation" buttons={buttons} filterValues={filterValues} refreshState={[refreshTable, setRefreshTable]} className='table-conversation' cells={cells} api={getConversations} actions={actions} supplementaryParamUrl={filterValues} setRefreshTable={setRefreshTable} refreshTable={refreshTable}  ></Table>
    );
}

export default ConversationTableInProgress;